import React from 'react';
import {
  CompareArrow,
  CompareCard,
  CompareHeading,
  CompareLine,
  CompareRow,
  NoticeText,
  WarningText,
} from './MemberAppLinkStyled';

/**
 * 연동 확인 단계 — 앱 계정과 CRM 대상을 나란히 보여주고 되돌릴 수 없음을 안내한다.
 * appAccount: {name, username, phoneNumber}, target: {name, phoneNumber, typeLabel}
 */
const LinkCompare = ({ appAccount, target }) => (
  <>
    <CompareRow>
      <CompareCard>
        <CompareHeading>앱 계정</CompareHeading>
        <CompareLine>이름 {appAccount?.name || '-'}</CompareLine>
        <CompareLine>아이디 {appAccount?.username || '-'}</CompareLine>
        <CompareLine>번호 {appAccount?.phoneNumber || '-'}</CompareLine>
      </CompareCard>
      <CompareArrow>⇄</CompareArrow>
      <CompareCard>
        <CompareHeading>CRM {target?.typeLabel}</CompareHeading>
        <CompareLine>이름 {target?.name || '-'}</CompareLine>
        <CompareLine>번호 {target?.phoneNumber || '-'}</CompareLine>
      </CompareCard>
    </CompareRow>
    <WarningText>
      연동하면 되돌릴 수 없고, CRM {target?.typeLabel}의 번호가 앱 계정 번호로 바뀝니다.
    </WarningText>
    {/* CRM 에서는 CRM 이름 우선 — 병합 때 지금 이름을 이 지점 별명으로 남긴다. 앱은 회원 본인 이름 */}
    {target?.name && appAccount?.name && target.name !== appAccount.name && (
      <NoticeText>
        CRM에서는 지금 이름 ‘{target.name}’ 그대로 보입니다. 회원앱에서는 앱 계정 이름 ‘{appAccount.name}’(으)로 보입니다.
      </NoticeText>
    )}
  </>
);

export default LinkCompare;
